import classnames from "classnames"
import PropTypes from "prop-types"
import React, { Component as C } from "react"

import styles from "../common-styles/styles.less"
import { sortableColumnIcons } from "../constants/index.es6"

import Html from "./html.jsx"

export default class extends C {
  static displayName = "TableHeaderColumn"

  static propTypes = {
    className: PropTypes.string,
    sortable: PropTypes.bool,
    direction: PropTypes.string,
    verticalAlign: PropTypes.oneOf(["baseline", "top", "bottom", "middle"]),
    onSorting: PropTypes.func,
    style: PropTypes.object,
  }

  render() {
    const { children, className, direction, onSorting, sortable, verticalAlign } = this.props

    const commonColumnClass = classnames(
      styles.th,
      className,
      styles[verticalAlign],
      sortableColumnIcons[direction],
    )
    const defaultColumnClass = commonColumnClass
    const sortableColumnClass = classnames(
      commonColumnClass,
      styles.thSortable,
      styles[verticalAlign],
      styles[direction],
    )

    const defaultColumn = (
      <Html
        type={this.props.htmlType}
        className={defaultColumnClass}
        colSpan={this.props.colSpan}
        style={this.props.style}
        id={this.props.id}
        role="columnheader"
        scope={this.props.scope}
        ariaHidden={this.props.ariaHidden}>
        {children}
      </Html>
    )

    const sortableColumn = (
      <Html
        type={this.props.htmlType}
        className={sortableColumnClass}
        onClick={onSorting}
        colSpan={this.props.colSpan}
        style={this.props.style}
        id={this.props.id}
        scope={this.props.scope}
        role="columnheader"
        ariaHidden={this.props.ariaHidden}>
        {children}
      </Html>
    )

    const column = sortable ? sortableColumn : defaultColumn

    return column
  }
}
